import '../sass/menu.scss';

(() => {
    const $blocks = document.querySelectorAll('.menu');

    $blocks?.forEach($block => {
        const $select = $block.querySelector('.menu__select');

        const initSelect = () => {
            if (!$select) return;

            $select.addEventListener('change', e => {
                const selected = Array.from(e.target.options).filter(option => option.selected);

                if (!selected?.[0]?.value) return;

                const { target } = selected[0].dataset;

                if (target === '_blank') {
                    window.open(selected[0].value, '_blank');

                    return;
                }

                window.location.href = selected[0].value;
            });
        };

        initSelect();
    });
})();
